import { render } from "./PlatformFooter.vue?vue&type=template&id=174a4fd4&scoped=true"
import script from "./PlatformFooter.vue?vue&type=script&lang=js"
export * from "./PlatformFooter.vue?vue&type=script&lang=js"

import "./PlatformFooter.vue?vue&type=style&index=0&id=174a4fd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174a4fd4"]])

export default __exports__